"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferencesDictionary = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const Features_1 = require("./api/Features");
const UIFeatures_1 = require("./api/UIFeatures");
exports.PreferencesDictionary = {
    [Features_1.Features.FreeRotation]: bridge_schema_1.PreferenceBoolOption.Full3dRotation,
    [Features_1.Features.BeatingHeart]: bridge_schema_1.PreferenceBoolOption.BeatingHeart,
    [Features_1.Features.Publicity]: bridge_schema_1.PreferenceBoolOption.PrivacyNotifications,
    [Features_1.Features.AutoSync]: bridge_schema_1.PreferenceBoolOption.AutoSync,
    [Features_1.Features.Hub]: bridge_schema_1.PreferenceBoolOption.ShowHub,
    [Features_1.Features.ModelUpdates]: bridge_schema_1.PreferenceBoolOption.ShowModelUpdatesIndicators,
    [Features_1.Features.PushNotifications]: bridge_schema_1.PreferenceBoolOption.PushNotifications,
    [UIFeatures_1.UIFeatures.Tabs]: bridge_schema_1.PreferenceBoolOption.ShowTabs,
    [UIFeatures_1.UIFeatures.Tools]: bridge_schema_1.PreferenceBoolOption.ShowTools,
    [UIFeatures_1.UIFeatures.SaveScreen]: bridge_schema_1.PreferenceBoolOption.ShowSaveScreenButton,
    [UIFeatures_1.UIFeatures.Record]: bridge_schema_1.PreferenceBoolOption.ShowRecordButton,
    [UIFeatures_1.UIFeatures.AR]: bridge_schema_1.PreferenceBoolOption.ShowARPanel,
    [UIFeatures_1.UIFeatures.Tips]: bridge_schema_1.PreferenceBoolOption.ShowTipsPanel,
    [UIFeatures_1.UIFeatures.SaveImage]: bridge_schema_1.PreferenceBoolOption.ShowExportButton,
    [UIFeatures_1.UIFeatures.NewScreensTooltip]: bridge_schema_1.PreferenceBoolOption.NewScreensTooltip,
};
